<template>
    <div class="exam2_page">
        <div class="exam2_page_header">
            <div class="exam2_page_header_title">
                Estás por comenzar tu examen
            </div>
        </div>
        <div class="exam2_page_description">
            El examen está divido en cinco niveles, desde Elemental hasta Avanzado.
Si respondes correctamente más del 50% de las preguntas en cada nivel, pasarás al siguiente. En caso contrario, el examen finalizará y pasarás a programar la fecha y hora en la que desees rendir la asesoría.
        </div>

        <div class="exam2_page_image">
            <img src="@/assets/images/exam/exam2.svg" alt="">
        </div>

        <div class="exam2_page_footer">
            <v-btn
                color="primary"
                class="uppercase"
                @click="registerExam"
                >
                Iniciar examen
            </v-btn>

            <router-link to="/exam" class="go_previous">
                 <v-icon style="font-size: 20px">navigate_before</v-icon> Anterior 
            </router-link>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
export default {
    data() {
        return {
            
        }
    },
    methods: {
        ...mapActions(['verifyPostulation']),
        registerExam() {
            this.$router.push({ path: `/evaluation` });
        }
    },
    computed: {
        ...mapGetters({
            language: "language",
            program: "program",
            postulation: "postulation",
            postulationIsNull: "postulationIsNull"
        })
    },
    mounted() {
        this.verifyPostulation();
        
        if(this.postulationIsNull){
            this.$router.push({ path: `/principal` });
        }
    },
}
</script>